import mixpanel from 'mixpanel-browser'

const hostname = window && window.location && window.location.hostname

if (hostname === 'app.bed-booking.com' || hostname === 'react.bed-booking.com' || hostname === 'pwa.bed-booking.com') {
  mixpanel.init('6e11ee3778b7bff044cf57983211f389')
} else {
  mixpanel.init('8efe7a069d331b3b3dac68b8c66675bc')
}

const actions = {
  alias: id => {
    mixpanel.alias(id)
  },
  identify: id => {
    mixpanel.identify(id)
  },
  register: data => {
    mixpanel.register(data)
  },
  people: {
    append: (id, name, value) => {
      mixpanel.identify(id)
      mixpanel.people.append(name, value)
    },
    increment: (id, name, value) => {
      mixpanel.identify(id)
      mixpanel.people.increment(name, value)
    },
    set: (id, props) => {
      mixpanel.identify(id)
      mixpanel.people.set(props)
    },
    union: (id, name, value) => {
      mixpanel.identify(id)
      mixpanel.people.union(name, value)
    },
  },
  track: (name, props) => {
    mixpanel.track(name, props)
  },
  reset: () => {
    mixpanel.reset()
  },
}

export const Mixpanel = actions
